import Quill, { Delta } from 'quill/core';
import React, { useEffect } from 'react';
import EmojiPicker, { EmojiPickerPopOver } from '../../components/EmojiPicker';
import { usePrefixListener } from '../PrefixListener';
import PrefixInputBackground from './PrefixInputBackground';

const USE_PREFIX_LISTENER_OPTIONS = [{ prefix: ':', isAllowedInTitle: true }];

interface EmojiAutocompleterProps {
  quill: Quill;
  readOnly: boolean;
}

const EmojiAutocompleter = ({ quill, readOnly }: EmojiAutocompleterProps) => {
  const { clientRects, text, prefix, reset } = usePrefixListener(
    quill,
    USE_PREFIX_LISTENER_OPTIONS,
  );
  const query = text ? text.toLowerCase() : '';
  const isShowingMenu = !!clientRects && !readOnly;

  useEffect(() => {
    if (/^\s/.test(query)) {
      reset?.();
    }
  }, [query, reset]);

  return (
    <>
      <EmojiPickerPopOver bounds={clientRects?.[0]} open={isShowingMenu}>
        <EmojiPicker
          inputContainer={quill.root}
          query={query}
          onPick={(emoji) => {
            reset?.();

            const range = quill.getSelection(true);
            if (range == null || text == null || prefix == null) return;
            const deletionLength = text.length + prefix.length;
            const index = range.index - deletionLength;
            quill.updateContents(
              new Delta().retain(index).delete(deletionLength).insert(emoji),
              Quill.sources.USER,
            );
            quill.setSelection(index + emoji.length, Quill.sources.USER);
          }}
          onEscapePress={() => reset?.()}
          onClearQuery={() => {
            const range = quill.getSelection(true);
            if (range == null || text == null || prefix == null) return;
            const deletionLength = text.length;
            const index = range.index - deletionLength;
            quill.updateContents(
              new Delta().retain(index).delete(deletionLength),
              Quill.sources.USER,
            );
            quill.setSelection(index, Quill.sources.USER);
          }}
        />
      </EmojiPickerPopOver>
      {clientRects && <PrefixInputBackground clientRects={clientRects} />}
    </>
  );
};

export default EmojiAutocompleter;
